import apiClient from '../api.js';
import { conToken } from '../autorizacion.js';

// Capa de servicios del catálogo de ítems (HU-13). Backend: `UNICEN/modules/economico`.
// Contrato completo: UNICEN/modules/economico/docs/items.openapi.yaml
//
// Token obligatorio, `{ data }`, errores `{ mensaje, campo? }` (leer con `errorDeApi`).
//
//   GET  /economico/items?buscar&estado=TODOS|ACTIVO|INACTIVO
//        &orden=estado|nombre|ultimo_cambio&direccion=asc|desc&pagina&limite
//        &incluir_congresos=true (por defecto no vienen)
//        (por defecto: activos primero y por nombre)
//        -> { items: [Item], total, pagina, limite }
//   GET  /economico/items/:id_item            -> Item + { historial: [Cambio] }
//   POST /economico/items  { nombre, detalle, forma_cobro? } -> 201 Item
//   PUT  /economico/items/:id_item { nombre, detalle, forma_cobro? } -> Item
//        (forma_cobro: UNICO | CUOTAS | PLAZOS; ver HU-05)
//   POST /economico/items/:id_item/desactivacion | /reactivacion -> Item
//        409 NombreDuplicado (campo: nombre), congreso no editable o sin cambios.
//
//   Item: { id_item, nombre, detalle, estado: 'ACTIVO'|'INACTIVO', tipo,
//           editable, creado, ultimo_cambio: { accion, id_usuario, usuario, fecha } }

const resource = '/economico/items';

const useItemsApi = {
  listar({ buscar, estado, incluir_congresos, orden, direccion, pagina, limite } = {}) {
    return apiClient.get(resource, conToken({
      params: { buscar, estado, incluir_congresos, orden, direccion, pagina, limite },
    }));
  },

  detalle(idItem) {
    return apiClient.get(`${resource}/${idItem}`, conToken());
  },

  crear({ nombre, detalle, forma_cobro }) {
    return apiClient.post(resource, { nombre, detalle, forma_cobro }, conToken());
  },

  editar(idItem, { nombre, detalle, forma_cobro }) {
    return apiClient.put(`${resource}/${idItem}`, { nombre, detalle, forma_cobro }, conToken());
  },

  desactivar(idItem) {
    return apiClient.post(`${resource}/${idItem}/desactivacion`, {}, conToken());
  },

  reactivar(idItem) {
    return apiClient.post(`${resource}/${idItem}/reactivacion`, {}, conToken());
  },
};

export default useItemsApi;
